module.exports = __webpack_public_path__ + "static/media/1AnyP8rQ.8c4a0f1b.png";